import './dropdown.jsx'
import './selection.jsx'
import './filebrowser'
import './fileselect'

addEventListener('DOMContentLoaded', (event) => {
	let textfields = document.querySelectorAll('ui-textfield')

	for (const textfield of textfields) {
		const input = textfield.querySelector('input')
		if (input) {
			input.addEventListener('focus', () => textfield.classList.add('focus'))
			input.addEventListener('blur', () => textfield.classList.remove('focus'))
		}
	}
})
